import {
  SET_ALL_DATES,
  SET_DASHBOARD_USER_TYPE,
  GET_SUMMARY_CARD_STATS,
  GET_SUMMARY_CARD_STATS_SUCCESS,
  GET_SUMMARY_CARD_STATS_FAIL,
  GET_REGISTERED_AGENTS_STATS_SUCCESS,
  GET_REGISTERED_AGENTS_STATS_FAIL,
  GET_REGISTERED_AGENTS_STATS,
  SET_REGISTERED_DATES,
  GET_ENABLED_AGENTS_STATS_SUCCESS,
  GET_ENABLED_AGENTS_STATS_FAIL,
  GET_ENABLED_AGENTS_STATS,
  SET_ENABLED_DATES,
  SET_REG_STATUS_DATES,
  SET_REG_STATUS_REGION,
  GET_AGENTS_PER_REG_STATS,
  GET_AGENTS_PER_REG_STATS_SUCCESS,
  GET_AGENTS_PER_REG_STATS_FAIL,
  SET_RATIO_DATES,
  SET_RATIO_REGION,
  GET_AGENTS_RATIO,
  GET_AGENTS_RATIO_SUCCESS,
  GET_AGENTS_RATIO_FAIL,
  SET_REGION_BREAKDOWN_DATES,
  GET_REGION_BREAKDOWN,
  GET_REGION_BREAKDOWN_SUCCESS,
  GET_REGION_BREAKDOWN_FAIL,
  SET_ADMIN_DATES,
  GET_ADMIN_STATS,
  GET_ADMIN_STATS_SUCCESS,
  GET_ADMIN_STATS_FAIL,
} from "../../types/dashboard/onboardingDashboardTypes";

const initialState = {
  userType: "AGENT",
  parentId: "",
  dates: {
    dateFrom: "",
    dateTo: "",
  },

  summaryCards: {
    loading: false,
    data: {},
  },

  registered: {
    data: {},
    dates: {
      dateFrom: "",
      dateTo: "",
    },
    loading: false,
  },

  enabled: {
    data: {},
    dates: {
      dateFrom: "",
      dateTo: "",
    },
    loading: false,
  },
  regStatus: {
    data: {},
    regionCode: null,
    dates: {
      dateFrom: "",
      dateTo: "",
    },
    loading: false,
  },
  agentAggregatorRatio: {
    data: {},
    regionCode: null,
    dates: {
      dateFrom: "",
      dateTo: "",
    },
    loading: false,
  },
  regionBreakdown: {
    data: {},
    dates: {
      dateFrom: "",
      dateTo: "",
    },
    loading: false,
  },
  admin: {
    data: {},
    dates: {
      dateFrom: "",
      dateTo: "",
    },
    loading: false,
  },
};

const onboardingDashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_DASHBOARD_USER_TYPE:
      return {
        ...state,
        userType: payload,
      };

    case SET_ALL_DATES:
      return {
        ...state,
        dates: payload,
        registered: {
          ...state.registered,
          dates: payload,
        },
        enabled: {
          ...state.enabled,
          dates: payload,
        },
        regStatus: {
          ...state.regStatus,
          dates: payload,
        },
        agentAggregatorRatio: {
          ...state.agentAggregatorRatio,
          dates: payload,
        },
        regionBreakdown: {
          ...state.regionBreakdown,
          dates: payload,
        },
        admin: {
          ...state.admin,
          dates: payload,
        },
      };

    case GET_SUMMARY_CARD_STATS:
      return {
        ...state,
        summaryCards: {
          ...state.summaryCards,
          loading: true,
        },
      };

    case GET_SUMMARY_CARD_STATS_SUCCESS:
      return {
        ...state,
        summaryCards: {
          ...state.summaryCards,
          data: payload,
          loading: false,
        },
      };

    case GET_SUMMARY_CARD_STATS_FAIL:
      return {
        ...state,
        summaryCards: {
          ...state.summaryCards,
          data: { isError: true },
          loading: false,
        },
      };

    case SET_REGISTERED_DATES: {
      return {
        ...state,
        registered: {
          ...state.registered,
          dates: {
            ...state.registered.dates,
            [payload.dateType]: payload.value,
          },
        },
      };
    }

    case GET_REGISTERED_AGENTS_STATS:
      return {
        ...state,
        registered: {
          ...state.registered,
          loading: true,
        },
      };

    case GET_REGISTERED_AGENTS_STATS_SUCCESS:
      return {
        ...state,
        registered: {
          ...state.registered,
          data: payload,
          loading: false,
        },
      };

    case GET_REGISTERED_AGENTS_STATS_FAIL:
      return {
        ...state,
        registered: {
          ...state.registered,
          data: { isError: true },
          loading: false,
        },
      };

    case SET_ENABLED_DATES: {
      return {
        ...state,
        enabled: {
          ...state.enabled,
          dates: {
            ...state.enabled.dates,
            [payload.dateType]: payload.value,
          },
        },
      };
    }

    case GET_ENABLED_AGENTS_STATS:
      return {
        ...state,
        enabled: {
          ...state.enabled,
          loading: true,
        },
      };

    case GET_ENABLED_AGENTS_STATS_SUCCESS:
      return {
        ...state,
        enabled: {
          ...state.enabled,
          data: payload,
          loading: false,
        },
      };

    case GET_ENABLED_AGENTS_STATS_FAIL:
      return {
        ...state,
        enabled: {
          ...state.enabled,
          data: { isError: true },
          loading: false,
        },
      };

    case SET_REG_STATUS_DATES: {
      return {
        ...state,
        regStatus: {
          ...state.regStatus,
          dates: {
            ...state.regStatus.dates,
            [payload.dateType]: payload.value,
          },
        },
      };
    }

    case SET_REG_STATUS_REGION: {
      return {
        ...state,
        regStatus: {
          ...state.regStatus,
          regionCode: payload,
        },
      };
    }

    case GET_AGENTS_PER_REG_STATS:
      return {
        ...state,
        regStatus: {
          ...state.regStatus,
          data: payload,
          loading: true,
        },
      };

    case GET_AGENTS_PER_REG_STATS_SUCCESS:
      return {
        ...state,
        regStatus: {
          ...state.regStatus,
          data: payload,
          loading: false,
        },
      };

    case GET_AGENTS_PER_REG_STATS_FAIL:
      return {
        ...state,
        regStatus: {
          ...state.regStatus,
          data: { isError: true },
          loading: false,
        },
      };

    case SET_RATIO_DATES: {
      return {
        ...state,
        agentAggregatorRatio: {
          ...state.agentAggregatorRatio,
          dates: {
            ...state.agentAggregatorRatio.dates,
            [payload.dateType]: payload.value,
          },
        },
      };
    }

    case SET_RATIO_REGION: {
      return {
        ...state,
        agentAggregatorRatio: {
          ...state.agentAggregatorRatio,
          regionCode: payload,
        },
      };
    }

    case GET_AGENTS_RATIO:
      return {
        ...state,
        agentAggregatorRatio: {
          ...state.agentAggregatorRatio,
          data: payload,
          loading: true,
        },
      };

    case GET_AGENTS_RATIO_SUCCESS:
      return {
        ...state,
        agentAggregatorRatio: {
          ...state.agentAggregatorRatio,
          data: payload,
          loading: false,
        },
      };

    case GET_AGENTS_RATIO_FAIL:
      return {
        ...state,
        agentAggregatorRatio: {
          ...state.agentAggregatorRatio,
          data: { isError: true },
          loading: false,
        },
      };

    case SET_REGION_BREAKDOWN_DATES: {
      return {
        ...state,
        regionBreakdown: {
          ...state.regionBreakdown,
          dates: {
            ...state.regionBreakdown.dates,
            [payload.dateType]: payload.value,
          },
        },
      };
    }

    case GET_REGION_BREAKDOWN:
      return {
        ...state,
        regionBreakdown: {
          ...state.regionBreakdown,
          data: payload,
          loading: true,
        },
      };

    case GET_REGION_BREAKDOWN_SUCCESS:
      return {
        ...state,
        regionBreakdown: {
          ...state.regionBreakdown,
          data: payload,
          loading: false,
        },
      };

    case GET_REGION_BREAKDOWN_FAIL:
      return {
        ...state,
        regionBreakdown: {
          ...state.regionBreakdown,
          data: { isError: true },
          loading: false,
        },
      };

    case SET_ADMIN_DATES: {
      return {
        ...state,
        admin: {
          ...state.admin,
          dates: {
            ...state.admin.dates,
            [payload.dateType]: payload.value,
          },
        },
      };
    }

    case GET_ADMIN_STATS:
      return {
        ...state,
        admin: {
          ...state.admin,
          data: payload,
          loading: true,
        },
      };

    case GET_ADMIN_STATS_SUCCESS:
      return {
        ...state,
        admin: {
          ...state.admin,
          data: payload,
          loading: false,
        },
      };

    case GET_ADMIN_STATS_FAIL:
      return {
        ...state,
        admin: {
          ...state.admin,
          data: { isError: true },
          loading: false,
        },
      };

    default:
      return state;
  }
};

export default onboardingDashboardReducer;
